import { call, put } from 'redux-saga/effects';
import { displaySimpleNotification } from 'features/notifications/simple-notifications/displaySimpleNotification';
import { sendPushContentSaga } from 'features/layout/features/content/sagas/sendPushContentSaga';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';

export function* pushContentSaga() {
  yield call(sendPushContentSaga, false);

  const notificationThunk: Action = yield call(displaySimpleNotification, {
    content: i18n.t('notifications:multi_tabs.content_pushed'),
  });

  yield put(notificationThunk);
}
